<template>
  <component
    ref="component"
    :is="dynamicComponentProps.is"
    :type="dynamicComponentProps.type"
    :items="dynamicComponentProps.items"
    :menu-props="{ auto: dynamicComponentProps.auto }"

    :label="titleText(label)"
    v-model="form"
    :rules="rules || (formRules && formRules.getRules && formRules.getRules())"
    :required="!!propSchema.required"
    :class="dynamicComponentProps.is === 'prism-editor' ? 'code-editor' : getFormInputClass(propSchema.type)"
    :style="getFormInputStyle(propSchema.type)"
    :placeholder="placeholder"

    :defaultForm="defaultForm"
    :propSchema="propSchema"
    :formRules="formRules"
    :rowClasses="rowClasses"
    :expand="expand"
    :flat="flat"
    :readonly="readonly"

    :highlight="highlighter"
    :line-numbers="true"
  />
</template>

<script>
  import MongoArrayItems from './MongoArrayItems'
  import { getDefaultPropValue, getComponentBindingData, MongoTableRules } from '../../libs/mongo-datatable'
  import { titleText, parseFormInputValue, getFormInputValue, isDefined } from '../../libs/utils'

  import { PrismEditor } from '../../../node_modules/vue-prism-editor';
  import '../../../node_modules/vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

  // import highlighting library (you can use any library you want just return html string)
  import { highlight, languages } from '../../../node_modules/prismjs/components/prism-core';
  import '../../../node_modules/prismjs/components/prism-clike';
  import '../../../node_modules/prismjs/components/prism-javascript';
  import '../../../node_modules/prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

  export default {
    name: 'MongoField',
    props: {
      value: { required: false },
      label: { required: false, default: '' },
      rules: { required: false, default: undefined },
      placeholder: { required: false, default: '' },
      // Passed props
      propSchema: { type: Object, required: true },
      formRules: { type: MongoTableRules, required: false, default: () => new MongoTableRules() },
      defaultForm: { required: false, default: () => ({}) },
      rowClasses: { type: String, required: false },
      expand: { type: Boolean, required: false, default: false },
      flat: { type: Boolean, required: false, default: false },
      readonly: { type: Boolean, required: false, default: false }
    },
    data () {
      return {
        form: undefined
      }
    },
    computed: {
      dynamicComponentProps () {
        const binding = { ...this.propSchema, value: this.value }
        return getComponentBindingData(binding)
      }
    },
    watch: {
      value: {
        deep: true,
        handler (val) {
          this.onValueChanged(val)
        }
      },
      form: {
        deep: true,
        handler (val) {
          val = getFormInputValue(this.propSchema.type, val)
          // console.log('field', JSON.stringify(val, null, 2))
          this.$emit('input', val)
        }
      }
    },
    mounted () {
      this.onValueChanged(this.value)
    },
    methods: {
      titleText,
      reset () {
        const { component } = this.$refs
        component['CUSTOM_FIELD'] && component.reset && component.reset()
      },
      getFormInputClass (type) {
        switch (type) {
          case Boolean: return ''
          default: return false
        }
      },
      getFormInputStyle (type) {
        switch (type) {
          case Boolean: return 'margin-top: 1.1em'
          default: return false
        }
      },
      onValueChanged (val) {
        val = isDefined(val) ? val : getDefaultPropValue(this.propSchema)
        this.form = parseFormInputValue(this.propSchema.type, val)
      },
      highlighter(code) {
        return highlight(code, languages.js)
      }
    },
    components: {
      MongoArrayItems,
      PrismEditor
    }
  }
</script>

<style lang="scss">
// required class
.code-editor {
  background: #2d2d2d;
  color: #ccc;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

// optional
.prism-editor__textarea:focus {
  outline: none;
}
</style>
